// Function loadAboutCompetitionBlock loads the AboutCompetitionBlock class by dynamically importing the js on demand if needed

export function loadAboutCompetitionBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-about-competition-block-chunk" */ '../widgets/aboutCompetitionBlock').then(wg => {

		const { AboutCompetitionBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="AboutCompetitionBlock"]');

		if(!$wg) {
			// console.info('AboutCompetitionBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="AboutCompetitionBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new AboutCompetitionBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new AboutCompetitionBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the AboutCompetitionBlock widget');

}
